/* tslint:disable */
/* eslint-disable */
/**
 * NGM Merchant Backend API (APIM)
 * Main API of the Sodexo NGM project
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * POS object status
 * @export
 * @enum {string}
 */

export enum PosStatusEnum {
    New = 'new',
    Active = 'active',
    Inactive = 'inactive',
    Failed = 'failed',
    Blocked = 'blocked',
    Canceled = 'canceled',
    Creating = 'creating',
    Deleting = 'deleting',
    Updating = 'updating',
    Activating = 'activating',
    Deactivating = 'deactivating',
    Blocking = 'blocking'
}



